<template>
  <div class="indicator">
    <div class="score before">
      {{ beforeLabel }}
    </div>
    <div class="arrow-track">
      <div class="arrow-line" />
      <span class="arrow-glyph">→</span>
    </div>
    <div class="score after" :class="afterClass">
      {{ afterLabel }}
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue"

const props = defineProps({
  before:     { type: Number, default: null },
  after:      { type: Number, default: null },
  inProgress: { type: Boolean, default: false },
})

function fmt(n) {
  if (n === null || n === undefined) return "—"
  return n.toFixed(1) + "%"
}

const beforeLabel = computed(() => fmt(props.before))
const afterLabel  = computed(() => {
  if (props.inProgress) return "…"
  return fmt(props.after)
})

const afterClass = computed(() => {
  if (props.inProgress) return "pending"
  if (props.after === null || props.before === null) return "pending"
  return props.after >= props.before ? "improved" : "regressed"
})
</script>

<style scoped>
.indicator {
  display: flex;
  align-items: center;
  gap: 8px;
}

.score {
  font-family: var(--font-mono);
  font-size: 13px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 4px;
  min-width: 48px;
  text-align: center;
}

.score.before {
  background: rgba(248, 113, 113, 0.15);
  color: #f87171;
}

.score.after.improved {
  background: rgba(74, 222, 128, 0.15);
  color: #4ade80;
}

.score.after.regressed {
  background: rgba(248, 113, 113, 0.15);
  color: #f87171;
}

.score.after.pending {
  background: rgba(251, 191, 36, 0.15);
  color: #fbbf24;
}

.arrow-track {
  display: flex;
  align-items: center;
  position: relative;
  flex: 1;
  min-width: 32px;
}

.arrow-line {
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background: rgba(245, 166, 35, 0.3);
}

.arrow-glyph {
  position: relative;
  font-family: var(--font-mono);
  font-size: 12px;
  color: #f5a623;
  margin: 0 auto;
}
</style>
